import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getWhatsAppAccount = createAsyncThunk('whatsapp/getAccount', async ({ accountId, domainId }) => {
  const response = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsapp/account`);
  return await response.json();
});

export const whatsappSlice = createSlice({
  name: 'whatsapp',
  initialState: {
    account: null,
    loading: null,
    error: null,
  },
  reducers: {
    setWhatsAppAccount: (state, action) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWhatsAppAccount.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getWhatsAppAccount.fulfilled, (state, action) => {
        const account = action.payload.whatsappAccount;
        state.account = account;
        state.loading = false;
      })
      .addCase(getWhatsAppAccount.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setWhatsAppAccount } = whatsappSlice.actions;

export default whatsappSlice.reducer;
